module.exports = __webpack_public_path__ + "static/media/rail.eab4bd9c.png";